import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import SingleError from '../helper/SingleError';

const MultipleSelected = ({ options, selectedStatus, handleSelect, label, index, activeDropdowns, error }) => {
    return (
        <Form.Group controlId="formGroupPassword" className="w-100">
            <Form.Label>{label}</Form.Label>
            <Dropdown
                className="status-btn"
            >
                <Dropdown.Toggle disabled={activeDropdowns === undefined}>
                    {
                        selectedStatus && selectedStatus?.length > 0
                            ? selectedStatus?.map((template) => template.name).join(', ')
                            :
                            'Select Template'}
                </Dropdown.Toggle>
                <Dropdown.Menu >

                    {options && options.map((option) => (
                        <Dropdown.Item
                            key={option._id}
                            eventKey={option._id}
                            className={selectedStatus?.some((template) => template._id === option._id) ? 'selected' : ''}
                            onClick={() => handleSelect(option, index)}
                        >

                            {/* {console.log("option", option)} */}
                            {option.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            <SingleError error={error} />
        </Form.Group>
    );
};

export default MultipleSelected;
